<template>
  <v-snackbar v-model="show" top :timeout="5000" :color="color">
    <svg-icon :icon-class="icon" class="mr6"></svg-icon>{{ message }}
  </v-snackbar>
</template>

<script>
export default {
  data: function() {
    return {
      show: false,
      message: "",
      type: "normal",
      color: "#49b1f5",
      icon: ""
    };
  },
  watch: {
    type(value) {
      switch (value) {
        case "error":
          this.color = "#F56C6C";
          this.icon = "error";
          break;
        case "success":
          this.color = "#52C41A";
          this.icon = "success";
          break;
        case "warnning":
          this.color = "#F57C00";
          this.icon = "warnning";
      }
    }
  }
};
</script>
<style lang="scss">
.v-snack__content{
  display: flex;
  align-items: center;
}
</style>
